export default __webpack_public_path__ + "static/media/Horne FL 10.e634cef7.JPEG";